module.exports = __webpack_public_path__ + "static/media/star-button.1ef5383a.svg";